const model = {
    submitting: false,
    errors: null,
    currencyDetails: null,
    success: false,
};

export default model;
